<template>
  <WithBackdrop
    :backdrop="data?.fields?.backdrop"
    :class="[$style.config, $style.wrap]"
  >
    <div :class="$style.inner">
      <BasePicture
        :src="`${data?.fields?.media?.fields?.file?.url}?fit=thumb&q=90`"
        alt=""
        :img-class="$style.logo"
      />
      <header :class="$style.header">
        <BaseHeading size="h4" as="h2" :class="$style.heading">
          {{ data?.fields?.header }}
        </BaseHeading>
        <MarkedParser
          :md="data?.fields?.copy"
          :class="['u-fs-p1', $style.copy]"
        />
      </header>
      <div :class="$style.ctas">
        <CallToAction
          v-for="cta in data.fields.ctas"
          :key="cta?.sys?.id"
          :class="$style.cta"
          :cta="cta"
        />
      </div>
    </div>
  </WithBackdrop>
</template>

<script setup lang="ts">
import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeContentBlockWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.config {
  @include breakpoint-variables(
    '--jw-wrap-padding',
    (
      base: 45px 20px,
    )
  );
}

.wrap {
  padding: var(--jw-wrap-padding);
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 800px;
  margin: 0 auto;

  @include media('md') {
    flex-direction: row;
    gap: 40px;
    max-width: 1400px;
  }
}

.logo {
  width: 100%;
  max-width: clamp(7.375rem, 6.944vw + 4.875rem, 11.125rem);
}

.header {
  text-align: center;
  color: var(--white);
  width: 100%;

  @include media('md') {
    text-align: left;
  }

  @include media('xl') {
    width: auto;
  }
}

.heading {
  margin-bottom: 10px;
}

.copy {
  @include fluid-type(18px, 20px);
}

.ctas {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  width: 100%;

  @include media('md') {
    margin-left: auto;
    max-width: 25%;
  }

  @include media('xl') {
    flex-direction: row;
    width: auto;
    max-width: none;
  }
}
</style>
